/* eslint-disable @typescript-eslint/ban-ts-comment */
import { getLoginRegion } from '../../utils/idk';
import { useAuthFetch } from '../use-auth-fetch';
import type { IdkConfig } from '../use-env-config';

type Region = {
  iss: string | undefined;
  aud: string;
};

/**
 * Hook to get the region for the user based on the IDK configuration and the user's ISS.
 *
 * @param {IdkConfig | undefined} idk - The IDK configuration.
 * @returns {{ region: IdkRegion }} - An object containing the region.
 */
export function useRegion(idk: IdkConfig | undefined) {
  const {
    data: region,
  }: {
    data: Region | null;
    loading: boolean;
    error: string | null;
  } = useAuthFetch('v1', {
    method: 'GET',
    resourceHostId: 'token-info-api',
  });

  // @ts-expect-error
  const iss: string = region?.iss;

  const loggedInRegion = idk && iss ? getLoginRegion(iss, idk?.issuerRegionMapping) : 'emea';

  return {
    region: loggedInRegion,
  };
}
